import { filters } from '@/config/data-tables/productHeaderAndFilter';
import { createDataTableFilterStore } from '@/utils/store';

// Empty string or null can be set for text filter
// but for dropdown filter, please set to null

const defaultFilters = Object.fromEntries(filters.map((filter) => [filter.key, null]));

const defaultSortKey = 'updated_at';
const defaultSortOrder = 'desc';

export const useProductFilterStore = createDataTableFilterStore(
  'product-filters',
  defaultFilters,
  defaultSortKey,
  defaultSortOrder
);
